var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 22.9167C18.2529 22.9167 22.9166 18.253 22.9166 12.5C22.9166 6.74703 18.2529 2.08333 12.4999 2.08333C6.74695 2.08333 2.08325 6.74703 2.08325 12.5C2.08325 18.253 6.74695 22.9167 12.4999 22.9167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 12.5H22.9166",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 22.9167C14.8011 22.9167 16.6666 18.253 16.6666 12.5C16.6666 6.74703 14.8011 2.08333 12.4999 2.08333C10.1987 2.08333 8.33325 6.74703 8.33325 12.5C8.33325 18.253 10.1987 22.9167 12.4999 22.9167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13428 5.28233C7.01932 7.16739 9.62349 8.33332 12.4999 8.33332C15.3765 8.33332 17.9806 7.16739 19.8657 5.28233",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8657 19.7176C17.9806 17.8326 15.3765 16.6667 12.4999 16.6667C9.62349 16.6667 7.01932 17.8326 5.13428 19.7176",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.261fc883a096cb2df361519d4e1c503b.svg";
export { ForwardRef as ReactComponent };